import React from "react";

export const PlusIcon = () => {
    return (
        <>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.54534 7.5625H6.14076V12.1579C6.14076 12.625 6.52497 13.0167 6.99958 13.0167C7.47419 13.0167 7.8584 12.625 7.8584 12.1579V7.5625H12.4538C12.9209 7.5625 13.3126 7.17829 13.3126 6.70368C13.3126 6.22907 12.9209 5.84487 12.4538 5.84487H7.8584V1.24944C7.8584 0.782366 7.47419 0.390625 6.99958 0.390625C6.52497 0.390625 6.14076 0.782366 6.14076 1.24944V5.84487H1.54534C1.07826 5.84487 0.686523 6.22907 0.686523 6.70368C0.686523 7.17829 1.07826 7.5625 1.54534 7.5625Z" fill="black" />
            </svg>

        </>
    )
}